export default {
  more: 'View more',
  retract: 'View less',
}
